import React, { useEffect, useRef } from 'react';

const ContactInformationPage = () => {
  const observerRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    observerRef.current = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.animation = 'fadeInUp 0.8s ease-out forwards';
        }
      });
    }, observerOptions);

    const animatedElements = document.querySelectorAll('.animate-on-scroll');
    animatedElements.forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(30px)';
      observerRef.current.observe(el);
    });

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  const contactDetails = [
    {
      title: "Head Office",
      icon: "fas fa-building",
      details: [
        { label: "Address", value: "Sudpara, Bolangir-767001, Odisha, India" },
        { label: "Phone", value: "+91 94370 31796" },
        { label: "Email", value: "roshanprasad.sbmi@gmail.com" },
        { label: "Contact Person", value: "Roshan Prasad" }
      ]
    },
    {
      title: "Manufacturing Unit",
      icon: "fas fa-industry",
      details: [
        { label: "Address", value: "Plot No. 10, 11, H17/2, Industrial Growth Centre Phase-I, Madhiapali, Bolangir-767065" },
        { label: "Phone", value: "+91 94373 68264" },
        { label: "Email", value: "alok.agrawal11@gmail.com" },
        { label: "Contact Person", value: "Alok Agrawal" },
        { label: "Capacity", value: "2,580 Tonnes/Year" }
      ]
    }
  ];

  const departments = [
    {
      title: "Sales & Marketing",
      icon: "fas fa-chart-line",
      phone: "+91 78736 48033",
      email: "avinashagr91@gmail.com",
      manager: "Sales Manager",
      hours: "Mon-Fri: 9:00 AM - 6:00 PM"
    },
    {
      title: "Technical Support",
      icon: "fas fa-cogs",
      phone: "+91 94373 68264",
      email: "alok.agrawal.11@bbindustry.in",
      manager: "Technical Manager",
      hours: "Mon-Fri: 9:00 AM - 5:00 PM"
    },
    {
      title: "Quality Assurance",
      icon: "fas fa-shield-check",
      phone: "+91 94373 68264",
      email: "alok.agrawal11@gmail.com",
      manager: "QA Manager",
      hours: "Mon-Fri: 9:00 AM - 5:00 PM"
    },
    {
      title: "Customer Service",
      icon: "fas fa-headset",
      phone: "+91 94370 31796",
      email: "roshanprasad.sbmi@gmail.com",
      manager: "Customer Service Manager",
      hours: "Mon-Sat: 9:00 AM - 6:00 PM"
    },
    {
      title: "Procurement",
      icon: "fas fa-shopping-cart",
      phone: "+91 94370 31796",
      email: "roshanprasad.sbmi@gmail.com",
      manager: "Procurement Manager",
      hours: "Mon-Fri: 9:00 AM - 5:00 PM"
    },
    {
      title: "Export Department",
      icon: "fas fa-globe",
      phone: "+91 78736 48033",
      email: "avinashagr91@gmail.com",
      manager: "Export Manager",
      hours: "Mon-Fri: 9:00 AM - 6:00 PM"
    }
  ];

  const socialMedia = [
    {
      platform: "LinkedIn",
      icon: "fab fa-linkedin",
      handle: "@bb-industries",
      url: "#",
      color: "#0077B5"
    },
    {
      platform: "Facebook",
      icon: "fab fa-facebook",
      handle: "@BBIndustries",
      url: "#",
      color: "#1877F2"
    },
    {
      platform: "Twitter",
      icon: "fab fa-twitter",
      handle: "@BB_Industries",
      url: "#",
      color: "#1DA1F2"
    },
    {
      platform: "Instagram",
      icon: "fab fa-instagram",
      handle: "@bb_industries",
      url: "#",
      color: "#E4405F"
    }
  ];

  const officeHours = [
    { day: "Monday - Friday", hours: "9:00 AM - 6:00 PM" },
    { day: "Saturday", hours: "9:00 AM - 2:00 PM" },
    { day: "Sunday", hours: "Closed" },
    { day: "Public Holidays", hours: "Closed" }
  ];

  return (
    <div className="contact-information-page">
      <style jsx>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .contact-information-page {
          font-family: 'Poppins', sans-serif;
          line-height: 1.6;
          color: #333;
          overflow-x: hidden;
        }

        .hero {
          background: linear-gradient(135deg, #5A1FB3 0%, #1E2329 100%);
          padding: 120px 0 80px;
          position: relative;
          overflow: hidden;
        }

        .hero::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" fill="%23ffffff" opacity="0.05"><polygon points="0,0 1000,0 1000,100 0,80"/></svg>');
          background-size: cover;
        }

        .hero-content {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 2rem;
          text-align: center;
          position: relative;
          z-index: 2;
        }

        .hero h1 {
          font-size: 3.5rem;
          font-weight: 800;
          color: white;
          margin-bottom: 1.5rem;
          line-height: 1.2;
        }

        .hero-subtitle {
          font-size: 1.3rem;
          color: rgba(255, 255, 255, 0.9);
          max-width: 800px;
          margin: 0 auto 2rem;
          font-weight: 400;
        }

        .hero-icon {
          width: 80px;
          height: 80px;
          background: #7B3FE4;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 2rem;
          box-shadow: 0 10px 30px rgba(123, 63, 228, 0.3);
        }

        .hero-icon i {
          font-size: 2rem;
          color: white;
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 2rem;
        }

        .section-header {
          text-align: center;
          margin-bottom: 4rem;
        }

        .section-header h2 {
          font-size: 2.8rem;
          font-weight: 700;
          background: linear-gradient(135deg, #7B3FE4 0%, #5A1FB3 100%);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          margin-bottom: 1rem;
        }

        .section-header p {
          font-size: 1.2rem;
          color: #666;
          max-width: 600px;
          margin: 0 auto;
        }

        .contact-details-section {
          padding: 100px 0;
          background: #F5F7FA;
        }

        .contact-details-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
          gap: 2rem;
        }

        .contact-card {
          background: white;
          padding: 3rem;
          border-radius: 16px;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
          transition: all 0.4s ease;
          border-top: 4px solid #7B3FE4;
        }

        .contact-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
        }

        .contact-card-header {
          display: flex;
          align-items: center;
          margin-bottom: 2rem;
        }

        .contact-card-icon {
          width: 60px;
          height: 60px;
          background: linear-gradient(135deg, #7B3FE4, #5A1FB3);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 1rem;
        }

        .contact-card-icon i {
          font-size: 1.5rem;
          color: white;
        }

        .contact-card h3 {
          font-size: 1.5rem;
          font-weight: 700;
          color: #6d7580;
        }

        .contact-details-list {
          list-style: none;
        }

        .contact-details-list li {
          padding: 0.8rem 0;
          border-bottom: 1px solid #F5F7FA;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
        }

        .contact-details-list li:last-child {
          border-bottom: none;
        }

        .detail-label {
          font-weight: 600;
          color: #6d7580;
          min-width: 80px;
        }

        .detail-value {
          color: #666;
          text-align: right;
          flex: 1;
          margin-left: 1rem;
          word-break: break-word;
          overflow-wrap: break-word;
          hyphens: auto;
        }

        .departments-section {
          padding: 100px 0;
          background: white;
        }

        .departments-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
          gap: 2rem;
        }

        .department-card {
          background: #F5F7FA;
          padding: 2.5rem;
          border-radius: 12px;
          transition: all 0.3s ease;
          border: 2px solid transparent;
        }

        .department-card:hover {
          border-color: #7B3FE4;
          transform: translateY(-3px);
        }

        .department-header {
          display: flex;
          align-items: center;
          margin-bottom: 1.5rem;
        }

        .department-icon {
          width: 50px;
          height: 50px;
          background: linear-gradient(135deg, #7B3FE4, #5A1FB3);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 1rem;
        }

        .department-icon i {
          font-size: 1.2rem;
          color: white;
        }

        .department-card h4 {
          font-size: 1.3rem;
          font-weight: 600;
          color: #6d7580;
        }

        .department-info {
          list-style: none;
        }

        .department-info li {
          padding: 0.5rem 0;
          display: flex;
          align-items: center;
        }

        .info-label {
          font-weight: 500;
          color: #6d7580;
          min-width: 60px;
          font-size: 0.9rem;
        }

        .info-value {
          color: #666;
          font-size: 0.9rem;
          margin-left: 0.5rem;
        }

        .office-hours-section {
          padding: 100px 0;
          background: linear-gradient(135deg, #6d7580 0%, #505A66 100%);
          color: white;
        }

        .office-hours-content {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .hours-list {
          background: rgba(255, 255, 255, 0.1);
          padding: 3rem;
          border-radius: 16px;
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.2);
          text-align: center;
          max-width: 500px;
        }

        .hours-list h2 {
          font-size: 2.2rem;
          font-weight: 700;
          margin-bottom: 1rem;
          color: white;
        }

        .hours-list p {
          font-size: 1.1rem;
          margin-bottom: 2rem;
          opacity: 0.9;
          line-height: 1.6;
          color: white;
        }

        .hours-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.8rem 0;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }

        .hours-item:last-child {
          border-bottom: none;
        }

        .hours-day {
          font-weight: 500;
          color: white;
        }

        .hours-time {
          color: rgba(255, 255, 255, 0.9);
        }

        .location-image-placeholder {
          background: rgba(255, 255, 255, 0.1);
          border-radius: 12px;
          overflow: hidden;
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.2);
        }

        .location-image {
          width: 100%;
          height: 300px;
          background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }

        .location-image::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" fill="white" opacity="0.1"><circle cx="20" cy="20" r="8"/><rect x="60" y="10" width="15" height="15" rx="3"/></svg>');
          background-repeat: repeat;
        }

        .image-content {
          text-align: center;
          color: white;
          position: relative;
          z-index: 2;
        }

        .image-content i {
          font-size: 3rem;
          margin-bottom: 1rem;
          display: block;
          opacity: 0.8;
        }

        .image-text {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 0.5rem;
        }

        .image-subtitle {
          font-size: 0.9rem;
          opacity: 0.8;
        }

        .image-caption {
          padding: 1.5rem;
          text-align: center;
        }

        .image-caption h4 {
          font-size: 1.1rem;
          font-weight: 600;
          color: white;
          margin-bottom: 0.5rem;
        }

        .image-caption p {
          color: rgba(255, 255, 255, 0.8);
          font-size: 0.9rem;
        }

        .map-section {
          padding: 100px 0;
          background: white;
        }

        .map-container {
          position: relative;
          margin-bottom: 2rem;
        }

        .map-info {
          margin-top: 2rem;
          display: flex;
          justify-content: center;
        }

        .map-location-card {
          background: #F5F7FA;
          padding: 2rem;
          border-radius: 16px;
          display: flex;
          align-items: center;
          max-width: 600px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
        }

        .location-icon {
          width: 60px;
          height: 60px;
          background: linear-gradient(135deg, #7B3FE4, #5A1FB3);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 1.5rem;
          flex-shrink: 0;
        }

        .location-icon i {
          font-size: 1.5rem;
          color: white;
        }

        .location-details h4 {
          font-size: 1.3rem;
          font-weight: 600;
          color: #1E2329;
          margin-bottom: 0.5rem;
        }

        .location-details p {
          font-size: 0.95rem;
          color: #4A5260;
          margin-bottom: 0.25rem;
          line-height: 1.4;
        }

        .social-media-section {
          padding: 80px 0;
          background: #F5F7FA;
        }

        .social-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 2rem;
        }

        .social-card {
          background: white;
          padding: 2rem;
          border-radius: 12px;
          text-align: center;
          transition: all 0.3s ease;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
        }

        .social-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
        }

        .social-icon {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1rem;
          transition: all 0.3s ease;
        }

        .social-icon i {
          font-size: 1.5rem;
          color: white;
        }

        .social-card h4 {
          font-size: 1.2rem;
          font-weight: 600;
          color: #6d7580;
          margin-bottom: 0.5rem;
        }

        .social-handle {
          color: #666;
          font-size: 0.95rem;
          margin-bottom: 1rem;
        }

        .social-button {
          display: inline-block;
          padding: 8px 16px;
          border-radius: 6px;
          color: white;
          text-decoration: none;
          font-size: 0.9rem;
          font-weight: 500;
          transition: all 0.3s ease;
        }

        .social-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
        }

        .cta-section {
          padding: 80px 0;
          background: linear-gradient(135deg, #7B3FE4 0%, #5A1FB3 100%);
          text-align: center;
          color: white;
        }

        .cta-content h2 {
          font-size: 2.5rem;
          font-weight: 700;
          margin-bottom: 1rem;
        }

        .cta-content p {
          font-size: 1.2rem;
          margin-bottom: 2rem;
          max-width: 600px;
          margin-left: auto;
          margin-right: auto;
          opacity: 0.9;
        }

        .cta-buttons {
          display: flex;
          gap: 1rem;
          justify-content: center;
          flex-wrap: wrap;
        }

        .cta-button {
          display: inline-block;
          padding: 15px 35px;
          background: white;
          color: #7B3FE4;
          text-decoration: none;
          border-radius: 8px;
          font-weight: 600;
          font-size: 1.1rem;
          transition: all 0.3s ease;
          cursor: pointer;
          border: none;
        }

        .cta-button:hover {
          background: #f0f0f0;
          transform: translateY(-3px);
          box-shadow: 0 8px 30px rgba(255, 255, 255, 0.3);
        }

        .cta-button-secondary {
          background: transparent;
          color: white;
          border: 2px solid white;
        }

        .cta-button-secondary:hover {
          background: white;
          color: var(--brand-purple, #7B3FE4);
        }

        @media (max-width: 768px) {
          .hero h1 {
            font-size: 2.5rem;
          }

          .hero-subtitle {
            font-size: 1.1rem;
          }

          .section-header h2 {
            font-size: 2.2rem;
          }

          .container {
            padding: 0 1rem;
          }

          .contact-details-grid {
            grid-template-columns: 1fr;
          }

          .office-hours-content {
            flex-direction: column;
          }

          .hours-list {
            padding: 2rem;
            max-width: 100%;
          }

          .cta-buttons {
            flex-direction: column;
            align-items: center;
          }

          .departments-grid {
            grid-template-columns: 1fr;
          }

          .contact-details-list li {
            flex-direction: column;
            align-items: flex-start;
          }

          .detail-value {
            text-align: left;
            margin-left: 0;
            margin-top: 0.25rem;
            font-size: 0.85rem;
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fade-in {
          animation: fadeInUp 0.8s ease-out;
        }
      `}</style>

      <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css" rel="stylesheet" />
      <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&display=swap" rel="stylesheet" />

      <section className="hero">
        <div className="hero-content">
          <div className="hero-icon animate-fade-in">
            <i className="fas fa-address-book"></i>
          </div>
          <h1 className="animate-fade-in">Visit Us</h1>
          <p className="hero-subtitle animate-fade-in">
            Find our locations and plan your visit to our Head Office and Manufacturing Unit
          </p>
        </div>
      </section>

      <section className="contact-details-section">
        <div className="container">
          <div className="section-header">
            <h2>Our Locations</h2>
            <p>Visit our Head Office and Manufacturing Unit in Bolangir, Odisha</p>
          </div>
          <div className="contact-details-grid">
            {contactDetails.map((contact, index) => (
              <div key={index} className="contact-card animate-on-scroll">
                <div className="contact-card-header">
                  <div className="contact-card-icon">
                    <i className={contact.icon}></i>
                  </div>
                  <h3>{contact.title}</h3>
                </div>
                <ul className="contact-details-list">
                  {contact.details.map((detail, i) => (
                    <li key={i}>
                      <span className="detail-label">{detail.label}:</span>
                      <span className="detail-value">{detail.value}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>


      <section className="office-hours-section">
        <div className="container">
          <div className="office-hours-content animate-on-scroll">
            <div className="hours-list">
              <h2>Office Hours</h2>
              <p>
                Our team is available during business hours to assist with your enquiries,
                provide technical support, and handle your business requirements.
              </p>
              {officeHours.map((hours, index) => (
                <div key={index} className="hours-item">
                  <span className="hours-day">{hours.day}</span>
                  <span className="hours-time">{hours.hours}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="map-section">
        <div className="container">
          <div className="section-header">
            <h2>Find Our Manufacturing Unit</h2>
            <p>Get directions to our manufacturing facility in Madhiapali, Bolangir</p>
          </div>
          <div className="map-container">
            <iframe
              
              src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3731.04967531873!2d83.49450877524896!3d20.748780580831397!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjDCsDQ0JzU1LjYiTiA4M8KwMjknNDkuNSJF!5e0!3m2!1sen!2sin!4v1759485166386!5m2!1sen!2sin"
              width="100%"
              height="400"
              style={{border: 0, borderRadius: '12px'}}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="B B Industry Manufacturing Unit Location"
            ></iframe>
            <div className="map-info">
              <div className="map-location-card">
                <div className="location-icon">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <div className="location-details">
                  <h4>Manufacturing Unit</h4>
                  <p>Plot No. 10, 11, H17/2, Industrial Growth Centre Phase-I</p>
                  <p>Madhiapali, Bolangir-767065, Odisha</p>
                  <p><strong>Contact:</strong> +91 94373 68264</p>
                  <p><strong>Contact Person:</strong> Alok Agrawal</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="social-media-section">
        <div className="container">
          <div className="section-header">
            <h2>Follow Us</h2>
            <p>Stay connected with us on social media for updates, news, and industry insights</p>
          </div>
          <div className="social-grid">
            {socialMedia.map((social, index) => (
              <div key={index} className="social-card animate-on-scroll">
                <div className="social-icon" style={{backgroundColor: social.color}}>
                  <i className={social.icon}></i>
                </div>
                <h4>{social.platform}</h4>
                <p className="social-handle">{social.handle}</p>
                <a 
                  href={social.url} 
                  className="social-button" 
                  style={{backgroundColor: social.color}}
                >
                  Follow Us
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Get In Touch Today</h2>
            <p>
              Ready to discuss your aluminium product requirements? Contact us through any of the channels above 
              or send us a detailed enquiry.
            </p>
            <div className="cta-buttons">
              <a href="/contact/enquiry-form" className="cta-button">
                Send Enquiry
              </a>
                <button className="cta-button cta-button-secondary" onClick={() => window.location.href = 'tel:+919437031796'}>

                Call Now
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactInformationPage;
